
















import {Vue, Component, Prop, Watch} from 'vue-property-decorator';
import {Mixins} from 'vue-property-decorator';
import GenericDialog from '@/components/Views/UI/GenericDialog.vue';
import {FeathersVuexFindAll} from '@/utils';
import {BookingDialogEntry, nil} from '@/common';
import GlobalAlertMixin from '@/mixins/GlobalAlertMixin.vue';
import BookingListItem from '@/components/Views/Dashboard/Booking/BookingListItem.vue';
@Component({
    components: {
        BookingListItem,
        GenericDialog,
    },
})
export default class GenericDeleteDialog extends Mixins(GlobalAlertMixin) {
    public open = false;
    public bookings: BookingDialogEntry[] = [];

    @Prop({default: 'Item'})
    public title!: string;

    @Prop({default: null})
    public feathersModel!: any;

    @Prop({default: () => null})
    public item!: any;

    @Prop({default: (() => [])})
    public onRefresh!: (() => Promise<BookingDialogEntry[]>);

    @Watch('open')
    public onOpenChanged(value: any, oldValue: any) {
        if (open) {
            this.onRefresh().then((res) => {
                this.bookings = res;
            });
        }
    }
    public close() {
        this.bookings = [];
        this.open = false;
    }
    public async attemptDelete() {
        const v = await this.feathersModel.get(this.item._id);
        try {
            await v.remove();
            this.showAlert(`${this.title} Deleted`, 'success');
            this.$emit('onDelete');
            this.close();
        } catch (e) {
            this.showAlert(`There was an error deleting this ${this.title.toLowerCase()}`, 'error');
        }
    }
    public get hasBookings() {
        return !nil(this.bookings, true);
    }
}
